import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { FullWidthFeatureCardStyles } from './FullWidthFeatureCard.styled';
import StArrowRightSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/st-arrow-right.svg';
import { isUrlInternal, isUrlSameDomain } from '@utils/utils';

const FullWidthFeatureCard = ({ card }) => {
  //links to other domains should open in a new window.
  const LinkWrapper = ({ url, onClick, children }) => {
    return isUrlInternal(url) ? (
      <Link href={url} className={card.gtm?.trigger} onClick={onClick}>
        {children}
      </Link>
    ) : (
      <a
        href={url}
        className={card.gtm?.trigger}
        onClick={onClick}
        target={isUrlSameDomain(url) ? '_self' : '_blank'}
        rel="noreferrer"
      >
        {children}
      </a>
    );
  };

  LinkWrapper.propTypes = {
    url: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
  };

  const getSectionLink = (url, txt) => {
    return url && txt ? (
      <LinkWrapper url={url}>
        <h4>
          {txt} <StArrowRightSvg />
        </h4>
      </LinkWrapper>
    ) : (
      ''
    );
  };

  return (
    <FullWidthFeatureCardStyles $featuredImage={card.featuredImage?.file?.url}>
      <section className="full-width-card">
        <div className="card-overlay">
          <div className="card-desc">
            <p>{card.sectionContent}</p>
          </div>
          <div className="card-link">
            {getSectionLink(card.sectionLink, card.sectionLinkText)}
          </div>
        </div>
      </section>
    </FullWidthFeatureCardStyles>
  );
};

export default FullWidthFeatureCard;

FullWidthFeatureCard.propTypes = {
  card: PropTypes.object,
};
